import React from 'react'
import LoginPage from '../../screens/LoginPage/LoginPage.component'

const LoginRoute: React.FC = () => {
  return (
    <LoginPage />
  )
}

export default LoginRoute
